import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const drawerDefaultVariants = {
  "side": "bottom",
  "size": "md"
}
const drawerCompoundVariants = [
  {
    "side": "top",
    "size": "md",
    "css": {
      "root": {
        "maxHeight": "80vh"
      }
    }
  },
  {
    "side": "top",
    "size": "full",
    "css": {
      "root": {
        "right": "0",
        "height": "100%",
        "maxHeight": "100vh"
      }
    }
  },
  {
    "side": "bottom",
    "size": "md",
    "css": {
      "root": {
        "maxHeight": "80vh"
      }
    }
  },
  {
    "side": "bottom",
    "size": "full",
    "css": {
      "root": {
        "right": "0",
        "height": "100%",
        "maxHeight": "100vh"
      }
    }
  },
  {
    "side": "left",
    "size": "md",
    "css": {
      "root": {
        "width": "80vw"
      }
    }
  },
  {
    "side": "left",
    "size": "full",
    "css": {
      "root": {
        "bottom": "0",
        "right": "0",
        "width": "100%"
      }
    }
  },
  {
    "side": "right",
    "size": "md",
    "css": {
      "root": {
        "width": "80vw"
      }
    }
  },
  {
    "side": "right",
    "size": "full",
    "css": {
      "root": {
        "bottom": "0",
        "left": "0",
        "width": "100%"
      }
    }
  }
]

const drawerSlotNames = [
  [
    "root",
    "Drawer__root"
  ],
  [
    "header",
    "Drawer__header"
  ],
  [
    "content",
    "Drawer__content"
  ],
  [
    "footer",
    "Drawer__footer"
  ]
]
const drawerSlotFns = /* @__PURE__ */ drawerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, drawerDefaultVariants, getSlotCompoundVariant(drawerCompoundVariants, slotName))])

const drawerFn = memo((props = {}) => {
  return Object.fromEntries(drawerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const drawerVariantKeys = [
  "side",
  "size"
]
const getVariantProps = (variants) => ({ ...drawerDefaultVariants, ...compact(variants) })

export const drawer = /* @__PURE__ */ Object.assign(drawerFn, {
  __recipe__: false,
  __name__: 'drawer',
  raw: (props) => props,
  variantKeys: drawerVariantKeys,
  variantMap: {
  "side": [
    "top",
    "bottom",
    "left",
    "right"
  ],
  "size": [
    "md",
    "full"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, drawerVariantKeys)
  },
  getVariantProps
})